/**
 * @packageDocumentation
 * @module api.functional.orders.pending
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { PaginationQuery } from "../../../structures/PaginationQuery";
import type { ServiceResponsePageOfPreorderundefined } from "../../../structures/ServiceResponsePageOfPreorderundefined";

/**
 * @controller PreorderController.getPending
 * @path GET /orders/pending
 * @accessor api.functional.orders.pending.getPending
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function getPending(
  connection: IConnection,
  query: getPending.Query,
): Promise<getPending.Output> {
  return PlainFetcher.fetch(connection, {
    ...getPending.METADATA,
    template: getPending.METADATA.path,
    path: getPending.path(query),
  });
}
export namespace getPending {
  export type Query = PaginationQuery;
  export type Output = ServiceResponsePageOfPreorderundefined;

  export const METADATA = {
    method: "GET",
    path: "/orders/pending",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (query: Query) => {
    const variables: URLSearchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(query as any))
      if (undefined === value) continue;
      else if (Array.isArray(value))
        value.forEach((elem: any) => variables.append(key, String(elem)));
      else variables.set(key, String(value));
    const location: string = "/orders/pending";
    return 0 === variables.size
      ? location
      : `${location}?${variables.toString()}`;
  };
}
